import React, { useState, useRef, useEffect } from 'react'
import { Tween, Timeline } from 'react-gsap';

const MotionTimeLine = () => {

    const emojiList = [
        {
            emoji: '🐶',
            name: 'dog'
        },
        {
            emoji: '🐱',
            name: 'cat'
        },
        {
            emoji: '🐼',
            name: 'panda'
        },
        {
            emoji: '🐯',
            name: 'tiger'
        },
    ]

    const [myEmoji, setMyEmoji] = useState(emojiList[0].emoji);
    const [myEmojiName, setMyEmojiName] = useState(emojiList[0].name);

    const emojiRef = useRef(null);
    const timeRef = useRef(null);
    const timeTargetRef = useRef(null);
    
    const handleChangeEmoji = (e) => {
        let thisEmoji = e.target.textContent;
        let thisEmojiName = e.target.nextSibling.textContent;

        setMyEmoji(thisEmoji);
        setMyEmojiName(thisEmojiName);

        emojiRef.current.tween.restart();
    }

    const handleRestart = () => {
        timeRef.current.timeline.restart();
    }

    const loadEmojiList = () => {
        timeTargetRef.current.classList.add('on');
    }

    // timeline motion
    const doEmojiListMotion = () => {
        let timeTarget = timeTargetRef.current.getElementsByTagName('li');
        timeRef.current.timeline.staggerFrom(timeTarget, 0.7, {y: 50, opacity: 0}, .05);
    }

    useEffect(() => {
        loadEmojiList();
        doEmojiListMotion();
    },[]);
    

    return ( 
        <>
            <section>

                <h2>Timeline</h2>
                <Timeline ref={timeRef}>

                    <ul className="profile-emoji" ref={timeTargetRef}>
                    {emojiList.map((emo, i) => {
                        return (
                            // timeline target
                            <li key={i} className="emo-list">
                                <button onClick={handleChangeEmoji} type="button">{emo.emoji}</button>
                                <span className="emo-name">{emo.name}</span>
                            </li>
                        )
                    })}
                    </ul>
                </Timeline>

                <button onClick={handleRestart}>restart</button>

                <div className="myemoji">
                    <Tween
                        ref={emojiRef}
                        from={{ rotation: -90, scale: 2 }}
                        duration={.5}
                    >
                        <span>{myEmoji}</span>
                    </Tween>            
                    <span className="emo-name">{myEmojiName}</span>
                </div>
            </section>

        </>
     );
}
 
export default MotionTimeLine;